<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->

    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/production/plan/mergeList" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('yilingshuliang')" required>
            <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.conditions.quantityAcquired" size="mini"> </el-input>
          </el-form-item>
          <el-form-item>千克</el-form-item>

          <el-form-item :label="$t('xianbiancang')" required>
            <yi_cross_select multiple :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="yt.conditions.materialId" @getItems="getItems"> </yi_cross_select>
          </el-form-item>

          <el-form-item>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #buttonsL="scope">
        <div required>选择材料</div>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <!-- <el-button size="mini" style="margin-right:1px" icon="yicon yicon-export" :title="$t('daochu')"  @click="exportExcel()">
				</el-button> -->
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_order_management_production_plan_combine',
  components: {
    // work_bom
  },
  data() {
    return {
      materialIdlist: [],
      materialIds: null,
      planIdList: [],
      planId: null,
      columns: [
        {
          label: 'xuanze',
          type: 'selection'
        },
        {
          label: 'wuliaobianma',
          prop: 'no',
          width: 130
        },
        {
          label: 'wuliaomingcheng',
          prop: 'erpNo',
          width: 130
        },
        {
          label: 'cangkubianma',
          prop: 'material.code',
          width: 130
        },
        {
          label: 'cangkumingcheng',
          prop: 'material.name'
        },
        {
          label: 'cangkuleixing',
          prop: 'quantity'
        },
        {
          label: 'cangkudizhi',
          prop: 'schedulingQuantity',
          width: 150
        },
        {
          label: 'kuqubianma',
          prop: 'material.code',
          width: 130
        },
        {
          label: 'kuqumingcheng',
          prop: 'material.name'
        },
        {
          label: 'kuweibianma',
          prop: 'material.code',
          width: 130
        },
        {
          label: 'kuweimingcheng',
          prop: 'material.name'
        },
        {
          label: 'kucunshuliang',
          prop: 'quantity'
        },
        {
          label: 'danwei',
          prop: 'org.name'
        }
        // {
        // 	label: 'caozuo',
        // 	type: 'slot',
        // 	width: 130,
        // 	fixed: 'right'
        // },
      ]
    };
  },

  created() {
    setTimeout(() => {
      // if(this.materialId) {
      this.yt.conditions = {
        materialId: this.materialId,
        pageSize: 1000
      };
      this.yt.get(1);
      this.yt.isShowPagination = false;
      // }
    }, 300);
  },
  methods: {
    selectionChange(items) {
      this.planIdList = items.map(item => {
        return item.id;
      });
      this.planId = items
        .map(item => {
          return item.no;
        })
        .join(',');
    },
    getItems(items) {
      this.materialIdlist = items;

      for (let i = 0; i < this.materialIdlist.length; i++) {
        this.materialId = this.materialIdlist[i]['id'];
      }
      console.log('this.materialId', this.materialId);
    }
  }
};
</script>
